import TextField from '../form/TextField'
import SelectField from '../form/SelectField'
import ImageField from '../form/ImageField'
import FileField from '../form/FileField'
import DateField, {formatDate} from '../form/DateField'
import TextareaField from '../form/TextareaField'
import RadioField from '../form/RadioField'
import CheckboxField from '../form/CheckboxField'
import MultiCheckboxField from '../form/MultiCheckboxField'

export {TextField}
export {SelectField}
export {ImageField}
export {FileField}
export {DateField, formatDate}
export {TextareaField}
export {RadioField}
export {CheckboxField}
export {MultiCheckboxField}

export const scrollToErrors = (errors) => {
	if (errors) {
		let el;
		for (let k in errors) {
			if (errors.hasOwnProperty(k)) {
				el = document.getElementById(k);
				if (el) {
					el.scrollIntoView();
					break
				}
			}
		}
	}
};